import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import * as _ from "../util/lodash";
var devices = {
  orientation: {
    MOBILE: 'mobile',
    MOBILE_VERTICALLY: 'mobile vertically',
    TABLET: 'tablet',
    TABLET_VERTICALLY: 'tablet vertically',
    COMPUTER: 'computer',
    COMPUTER_VERTICALLY: 'computer vertically'
  },
  sizes: {
    MOBILE: 'mobile',
    TABLET: 'tablet',
    TABLET_AND_MOBILE: 'tablet mobile',
    COMPUTER_1X: 'computer',
    COMPUTER_2X: 'large screen',
    COMPUTER_3X: 'widescreen'
  }
};
devices.orientation.ALL = _valuesInstanceProperty(_).call(_, devices.orientation);
devices.sizes.ALL = _valuesInstanceProperty(_).call(_, devices.sizes);
export default devices;
//# sourceMappingURL=devices.js.map